var sFCCReferralSourceCodeStorageKey = 'SFCCReferralSourceCode';
export var getSFCCReferralSourceCode = function () {
    var sourceCode = sessionStorage.getItem(sFCCReferralSourceCodeStorageKey);
    return sourceCode !== null && sourceCode !== void 0 ? sourceCode : undefined;
};
export var saveSFCCReferralSourceCode = function (sourceCode) {
    sessionStorage.setItem(sFCCReferralSourceCodeStorageKey, sourceCode);
};
export var removeSFCCReferralSourceCode = function () {
    sessionStorage.removeItem(sFCCReferralSourceCodeStorageKey);
};
